<template>
  <!--页面加载动画-->
  <div class="select-box">
    <span class="defaultTxt" @click="showDatas(1)">
      {{defaultTxt || "请选择"}}
      <i class="iconfont icondiqu"></i>
    </span>
    <van-popup v-model="showLayer" position="bottom">
      <van-picker
        ref="areas"
        show-toolbar
        title="地区选择"
        :columns="slotsData"
        value-key="name"
        @cancel="handleCancle"
        @confirm="handleSure"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allData: new Array(), //选择元素
      showLayer: false, //是否弹窗选择框
      hasDatas: false, //数据是否加载完成
      defaultTxt: "", //是否弹窗选择框
      checkItem: [], //当前滑动选择项
      itemNum: 3 //默认级联数
    };
  },
  props: ["selectData", "proId"],
  mounted() {
    this.getName();
    // this.initDatas();
    if(this.selectData.type){
        this.itemNum=this.selectData.type
    }
  },
  computed: {

    slotsData() {
      if(this.allData && this.allData.length>0){
        let data = this.initCitys(this.allData);
        console.log(data);

        return data;
      }
    }
  },
  methods: {
    initCitys(data) {
      //munt 选择回调-确认
      data.forEach(item=>{
        if(item.children && item.children.length>0 && item.level!=3){
          this.initCitys(item.children)
        }else if(item.level!=3){
          item.children=[""]
        }
        if(item.level==2 && this.itemNum==2){
          item.children=null;
        }
      })
      return data;
    },
    //控制弹窗显示
    showDatas(type){
      setTimeout(_=>{
        if(this.hasDatas && type==1){
          this.showLayer=true
        }else if(!this.hasDatas && type==1){
          this.$notice.msg("正在加载地区数据，请稍后几秒钟！");
        }else if(type==2){
          this.showLayer=false
        }
      },100)
    },
    getName(){
      //获取当前地区
      let data=this.selectData.elementValue;
      if(_.isArray(data)){
        let txt='';
        data.forEach(item=>{
          txt+=item.name+" "
        })
        this.defaultTxt=txt;
      }else{
        this.defaultTxt=data;
      }
    },
    handleSure(e,v) {
      //munt 选择回调-确认
      console.log(e);
      this.updateCity();
      this.showDatas(2)
      this.defaultTxt = this.getCityName();
      this.getResult();
    },
    handleCancle() {
      //munt 选择回调-取消
      this.showDatas(2)
    },
    updateCity() {
      const indexs=this.$refs.areas.getIndexes();
      const data=this.allData;
      this.checkItem[0]={
        level:0,
        name: data[indexs[0]].name,
        code: data[indexs[0]].code,
      }
      this.checkItem[1]={
        level:1,
        name:  _.get(data,`[${indexs[0]}].children[${indexs[1]}].name`,''),
        code:  _.get(data,`[${indexs[0]}].children[${indexs[1]}].code`,''),
      }
      if(this.itemNum==3){
        this.checkItem[2]={
          level:2,
          name:  _.get(data,`[${indexs[0]}].children[${indexs[1]}].children[${indexs[2]}].name`,''),
          code:  _.get(data,`[${indexs[0]}].children[${indexs[1]}].children[${indexs[2]}].code`,''),
        }
      }
      console.log(this.checkItem);

    },
    getCityName() {
      let name = "";
      for (let k = 0; k < this.itemNum; k++) {
        name += this.checkItem[k].name ? this.checkItem[k].name+" ": "";
      }
      return name;
    },
    initDatas() {
      //初始化城市数据
      const productCode = this.$store.state.productBaseInfo.productCode
      this.$http({
          url: "/insure/regions",
          type:'GET',
          data: {
            productCode: productCode,
            type:this.selectData.params || ""
          }
        })
        .then(data => {
          if(!data.data)return;
          let allData = data.data;
          this.allData = allData;
          this.hasDatas = allData && allData.length>1?true:false;
          console.log(this.checkItem);

        })
        .catch(err => {
          console.log(err);
        });
    },
    getResult() {
      //选择后回调到父组件
      let value = this.checkItem;
      this.selectData.elementValue=value;
      this.$emit("selected", {
        type:1,
        item:this.selectData,
        value: value
      });
    }
  },
  watch: {
    selectData(newVal) {
    }
  }
};
</script>

<style lang="scss" scoped>
.select-box {
  width: 100%;
  height: 100%;
  .iconfont {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #0084ff;
  font-size: 36px;
  opacity: 0.7;
}
}
.defaultTxt {
  width: 100%;
  height: 100%;
  line-height: 40px;
  font-size: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 50px;
  display: inline-block;
}

.select-layer-box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 1;
  }
  .mainContent {
    position: absolute;
    width: 10rem;
    left: 50%;
    bottom: 0;
    z-index: 2;
    background-color: #fff;
    transform: translateX(-50%);
  }
  .btn {
    line-height: 40px;
    padding: 0 20px;
  }
  .btn-cancle {
    float: left;
  }
  .btn-sure {
    float: right;
    color: #0084ff;
  }
}
</style>
